// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f4c85347","455":"e6f17f2b"}[chunkId] + ".chunk.js";
};